import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DataUnitOPEEnum} from "./DataUnitOPEEnum";

class O {
}

/**
 * O Inner Class
 */
class I {
  id!: number;
}

export class DelDataUnitCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DataUnitOPEEnum.DelDataUnit);
    this.i = new I();
    this.o = new O();
  }
}
